import { Guid } from "guid-typescript";

export class ReportInstruction {
    instructions: string;
    reportId:Guid;
    reportTab:string;
  }
